const mapWidthToPct = ({ modalWidth, screenWidth }) => {
    switch (modalWidth) {
        case 'sm':
            if (screenWidth === 'sm-down')
                return 90;
            if (screenWidth === 'md-only')
                return 50;
            return 33;
        case 'md':
            if (screenWidth === 'sm-down')
                return 90;
            if (screenWidth === 'md-only')
                return 66;
            return 50;
        case 'lg':
            if (screenWidth === 'sm-down')
                return 90;
            if (screenWidth === 'md-only')
                return 90;
            return 66;
        default:
            return 90;
    }
};
export const getContentWidth = ({ modalWidth, screenWidth, }) => {
    return `${mapWidthToPct({ modalWidth, screenWidth })}vw`;
};
export const getContentMaxWidth = (modalWidth) => {
    // TODO: we should add this to the them at some point (maxAppWidth)
    // it's also used in the @ally/next-layout lib
    const maxAppWidth = 1176;
    return `${Math.floor(maxAppWidth * (mapWidthToPct({ modalWidth, screenWidth: 'lg-up' }) / 100))}px`;
};
//# sourceMappingURL=utils.js.map